import { RouterModule, Routes } from '@angular/router';
import { HomeInventoryComponent } from './components/home-inventory/home-inventory.component';
import { WizardInventoryComponent } from './components/wizard-inventory/wizard-inventory.component';
import { ReportInventoryComponent } from './components/report-inventory/report-inventory.component';


import { TechnicalServiceGuard } from '../guards/technicalService.guard';



export const InventoryRouter: Routes = [
    { path: '', component: HomeInventoryComponent , canActivate: [TechnicalServiceGuard]},
    { path: 'wizard/:id', component: WizardInventoryComponent , canActivate: [TechnicalServiceGuard]},
    { path: 'report', component: ReportInventoryComponent , canActivate: [TechnicalServiceGuard]},
];


// WEBPACK FOOTER //
// ./src/app/inventory/inventory.router.ts